import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/useraction/organization_user_add/`;
export const Csrf = () => `/api/v3/useraction/token/`;
export declare const QueryKey: never;
export type Payload = {
    firstName: string;
    lastName: string;
    email: string;
    role: `${Models.Organizations.OrganizationMemberRole}`;
};
export type Response = Models.UserAction.OrganizationUser;
